import React from 'react';
import { useEvent } from '@/store';
import Script from 'next/script';
import { isSubdomainBlocked } from '@/config/blockPixelConfig';

function FBPixel() {
  const { event } = useEvent();
  const blockPixel = isSubdomainBlocked(event?.event?.subdomain);

  if (blockPixel) return null;

  let accounts = [];
  if (event.facebook_pixel) {
    accounts = [event.facebook_pixel];
  }
  if (process.env.NEXT_PUBLIC_FB_PIXEL && event?.event?.subdomain) {
    accounts = [process.env.NEXT_PUBLIC_FB_PIXEL, ...accounts];
  }

  return (
    <>
      {accounts.map((key) => (
        <Script
          id={`fbpixel-${key}`}
          key={key}
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: `!function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '${key}');
          fbq('track', 'PageView');`,
          }}
        ></Script>
      ))}
    </>
  );
}

export default FBPixel;
